import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import PositioningStatement from './components/PositioningStatement';
import CoreOffer from './components/CoreOffer';
import IndustriesServed from './components/IndustriesServed';
import Differentiator from './components/Differentiator';
import Process from './components/Process';
import MetricsStrip from './components/MetricsStrip';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <PositioningStatement />
      <CoreOffer />
      <IndustriesServed />
      <Differentiator />
      <Process />
      <MetricsStrip />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default HomePage;
